import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_ALL_SERVERS} from "../../graphql/queries/server/all";
import {SERVER_DELETE} from "../../graphql/mutations/server/delete";

const state = {
  servers: []
};

const getters = {
  serversAll: (state) => state.servers,
  serversByStatus: (state) => (statusCode) => {
    return state.servers.filter(server => server.status === statusCode)
  },
  serverById: (state) => (id) => state.servers.find(server => server.id === id)
};

const mutations = {
  UPDATE_SERVER_LIST (state, servers) {
    state.servers = servers;
  },
  DELETE_SERVER (state, id) {
    state.servers = state.servers.filter(server => server.id !== id)
  }
};

const actions = {
  async serverFetchList ({commit}) {
    const {data} = await apolloClient.query({query: GET_ALL_SERVERS});
    if (data && data.serverList) {
      commit('UPDATE_SERVER_LIST', data.serverList);
    }
  },
  async serverDeleteById({commit}, id) {
    const {data} = await apolloClient.mutate({mutation: SERVER_DELETE, variables: {id: id}});
    if (data && data.serverDelete) {
      commit('DELETE_SERVER', id);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/servers.js